import {Card} from "../../../../../components/card/card.jsx";
import {classNameUtils} from "../../../../../utils/class-name-utils.js";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {useMemo} from "react";
import {fluidPx} from "../../../../../utils/responsive-graph.js";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";

const customStyle = classNameUtils.cardVariants("customMenu");

const MaterialsGraph = ({data}) => {
  const vw = useGraphViewportWidth();
  const hasMaterialGroups = Array.isArray(data)
    ? data.length > 0
    : (data?.topMaterialGroupsByQuantity?.length ?? 0) > 0;

  const topMaterialGroupsOption = useMemo(() => {
    const materialGroups = Array.isArray(data) ? data : data?.topMaterialGroupsByQuantity ?? [];
    if (!materialGroups.length) return {};

    const labelFs = fluidPx(11, 18, vw);
    const names = materialGroups.map(({material_group_name}) => material_group_name);
    const totals = materialGroups.map(({total}) => Number(total ?? 0));

    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {type: 'shadow'},
        extraCssText: 'max-width: 320px; white-space: normal;',
        formatter: ([params]) => (
          params.marker + ' ' + params.name + ': <b>' + Number(params.value).toLocaleString('pt-BR') + '</b>'
        )
      },
      grid: {top: 12, left: 12, right: 24, bottom: 12, containLabel: true},
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: labelFs,
          color: '#676a6c',
          formatter: value => Number(value).toLocaleString('pt-BR')
        },
        axisLine: {
          lineStyle: {color: '#BEBEBE'}
        },
        axisTick: {show: false},
        splitLine: {show: false}
      },
      yAxis: {
        type: 'category',
        data: names,
        inverse: true,
        axisLabel: {
          fontSize: labelFs,
          color: '#676a6c',
          width: 150,
          overflow: 'truncate'
        },
        axisLine: {
          lineStyle: {color: '#BEBEBE'}
        },
        axisTick: {show: false}
      },
      series: [{
        name: 'Quantidade',
        type: 'bar',
        barMaxWidth: 32,
        data: totals,
        itemStyle: {
          color: '#20609D',
          borderRadius: [0, 8, 8, 0]
        }
      }]
    };
  }, [data, vw]);

  return(
    <Card className="col-span-3 h-full min-h-0 flex flex-col">
      <Card.Header className={customStyle.header}>
        <Card.Title className={customStyle.title}>Total de materiais</Card.Title>
      </Card.Header>
      <Card.Body className={customStyle.body}>
        {hasMaterialGroups ? (
          <SentryEchart
            option={topMaterialGroupsOption}
            title="Top 5 grupos"
            titleClass="text-[#676a6c]!"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-center text-sm text-[#676a6c]">
            Nenhum material registrado.
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default MaterialsGraph;
